export default "__VITE_ASSET__308fTuOj__"